import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { IssuesIcon } from '../../icons/IssuesIcon';
import { LogoIcon } from '../../icons/LogoIcon';
import { OrgsIcon } from '../../icons/OrgsIcon';
import { UsersIcon } from '../../icons/UsersIcon';
import { Flex } from '../../components/Flex';
import { NavigationItem } from './NavigationItem';
import { ContractsIcon } from '../../icons/ContractsIcon';
import { PackagesIcon } from '../../icons/PackagesIcon';
import { AuditIcon } from '../../icons/AuditIcon';
import { Scrollbar } from '../../components/Scrollbar';

const MenuItem = styled(Link)`
    ${({ selected }) => selected && css`
        background: rgba(96, 146, 226, .3);
    `}

    min-height: 48px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0px 20px;
    text-decoration: none;

    &:not(:last-child) {
        margin-bottom: 20px;
    }

    & > div:not(:last-child) {
        margin-right: 12px;
    }
`;

const NavigationMenu = ({ selected, collapsed, isContractsRead }) => {
    const menu = [
        {
            key: "organisations",
            icon: <OrgsIcon />
        },
        {
            key: "users",
            icon: <UsersIcon />
        },
        {
            key: "issues",
            icon: <IssuesIcon />
        },
        {
            key: "packages",
            icon: <PackagesIcon />
        },
        {
            key: "audit",
            icon: <AuditIcon />
        }
    ];

    if (isContractsRead) menu.push({
        key: "contracts",
        icon: <ContractsIcon />
    })

    return(
        <>
            <MenuItem to={`/dashboard`}>
                <LogoIcon collapsed={collapsed} />
            </MenuItem>
            <Flex height="calc(100% - 163px)" margin={{ bottom: "20px" }}>
                <Scrollbar>
                    {menu.map(item => (
                        <MenuItem key={item.key} to={`/${item.key}`} selected={item.key === selected}>
                            <NavigationItem item={item} collapsed={collapsed} selected={item.key === selected} />
                        </MenuItem>
                    ))}
                </Scrollbar>
            </Flex>
        </>
    )
};

export { NavigationMenu };